import createIcon from '../../createIcon';

/**
 * @component @name Workspaces
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxM0MzLjggMTMgMiAxNC44IDIgMTdDMiAxOS4yIDMuOCAyMSA2IDIxQzguMiAyMSAxMCAxOS4yIDEwIDE3QzEwIDE0LjggOC4yIDEzIDYgMTNaTTEyIDNDOS44IDMgOCA0LjggOCA3QzggOS4yIDkuOCAxMSAxMiAxMUMxNC4yIDExIDE2IDkuMiAxNiA3QzE2IDQuOCAxNC4yIDMgMTIgM1pNMTggMTNDMTUuOCAxMyAxNCAxNC44IDE0IDE3QzE0IDE5LjIgMTUuOCAyMSAxOCAyMUMyMC4yIDIxIDIyIDE5LjIgMjIgMTdDMjIgMTQuOCAyMC4yIDEzIDE4IDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Workspaces = createIcon('Workspaces', [
  [
    'path',
    {
      d: 'M6 13C3.8 13 2 14.8 2 17C2 19.2 3.8 21 6 21C8.2 21 10 19.2 10 17C10 14.8 8.2 13 6 13ZM12 3C9.8 3 8 4.8 8 7C8 9.2 9.8 11 12 11C14.2 11 16 9.2 16 7C16 4.8 14.2 3 12 3ZM18 13C15.8 13 14 14.8 14 17C14 19.2 15.8 21 18 21C20.2 21 22 19.2 22 17C22 14.8 20.2 13 18 13Z',
      key: '1wq3ay',
    },
  ],
]);

export default Workspaces;
